export const STORAGE_KEYS = {
  clanInvitation: process.env.REACT_APP_KEY_CLAN_INVITATION,
};
